import React from "react"
import api from "src/api"
import { buildSearchFilter } from "src/utils/build-search-filter"

const SEARCH_FIELDS = ["id", "title"]

export function useGetData() {
  const [dataBanners, setDataBanners] = React.useState([])

  const [isLoading, setIsLoading] = React.useState(false)
  const [pagination, setPagination] = React.useState(null)
  const [appliedFilters, setAppliedFilters] = React.useState("")


  React.useEffect(() => {
    getItems()
  }, [])

  const getItems = (page = 1, countOnPage = 20, filters = "") => {
    setIsLoading(true)
    api.get(`banners?page=${page}&countOnPage=${countOnPage}${filters}`).then(({ data }) => {
      setPagination({
        current: data.pagination.currentPage,
        pageSize: data.pagination.countOnPage,
        total: data.pagination.total,
      })
      setDataBanners(getFormattedItems(data.items))
    })

    setIsLoading(false)
  }

  function handleTableChange(pagination) {
    getItems(pagination.current, pagination.pageSize, appliedFilters)
  }

  function handleSearchTable(value) {
    const filters = buildSearchFilter(value, SEARCH_FIELDS)
    setAppliedFilters(filters)
    getItems(1, 20, filters)
  }

  function getFormattedItems(items) {
    const newItems = []

    items.forEach((item) => {
      let newItem = {
        ...item,
        key: item.id,
        titleRu: item.title.find((el) => el.language === "ru")?.content,
        descriptionRu: item.title.find((el) => el.language === "ru")?.content
      }
      newItems.push(newItem)
    })

    return newItems
  }

  return {
    dataBanners,
    pagination,
    isLoading,
    handleTableChange,
    handleSearchTable,
    refetch: () => getItems(pagination?.current || 1, pagination?.pageSize || 20, appliedFilters),
    formatted: () => getFormattedItems()
  }
}
